var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6247 9.10417C16.6247 12.8206 13.6119 15.8333 9.8955 15.8333C9.04305 15.8333 8.22762 15.6748 7.47708 15.3857C7.33985 15.3328 7.27124 15.3064 7.21668 15.2938C7.16301 15.2814 7.12417 15.2763 7.06913 15.2742C7.01318 15.272 6.9518 15.2784 6.82903 15.2911L2.77488 15.7101C2.38836 15.7501 2.19509 15.7701 2.08109 15.7005C1.9818 15.6399 1.91416 15.5388 1.89616 15.4239C1.87549 15.2919 1.96784 15.121 2.15255 14.7791L3.44744 12.3823C3.55408 12.1849 3.6074 12.0862 3.63155 11.9913C3.6554 11.8976 3.66117 11.83 3.65354 11.7336C3.64582 11.636 3.60299 11.5089 3.51733 11.2548C3.28971 10.5795 3.16633 9.85625 3.16633 9.10417C3.16633 5.38775 6.17908 2.375 9.8955 2.375C13.6119 2.375 16.6247 5.38775 16.6247 9.10417Z",
    stroke: "#AFAFAF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircle);
export default __webpack_public_path__ + "static/media/circle.ecd8eabca29d256b84ae9f887ad717b3.svg";
export { ForwardRef as ReactComponent };